import SearchHeader from '../../components/Headers/SearchHeader';
import SearchResults from './searchGrid/SearchResults';
import { searchContext } from '../../context/Context';
import LoadingSpinner from '../../global/Loader/LoaderSpinner';
import { SearchContext } from '../../types';
import { useReducer } from 'react';
import { initialState, searchComponentReducer } from './reducers/searchComponentReducer';
import EvidenceSummaryModal from './searchGrid/components/modal/EvidenceSummaryModal';

export default function Search() {
  const { view, source, tab, hasValidParams } = searchContext() as unknown as SearchContext;
  const [state, dispatch] = useReducer(searchComponentReducer, initialState);

  return (
    <>
      <SearchHeader />
      {hasValidParams && view && source && tab ? (
        <div>
          <SearchResults state={state} dispatch={dispatch} />
          {state.isLoading && <LoadingSpinner />}
        </div>
      ) : (
        <LoadingSpinner />
      )}

      <EvidenceSummaryModal
        open={state.showEvidenceModal}
        onClose={() => dispatch({ type: 'SET_SHOW_EVIDENCE_MODAL', payload: false })}
        content={state.evidenceModalContent}
        data={state.evidenceModalData}
      />
    </>
  );
}
